const config = {
  BASE_API: 'https://ife-api.cinesend.com/api/'
}

export default config